import React, { useState } from 'react';
import { IconPlus, IconSquareCheck, IconSettings, IconLogout, IconUsersGroup, IconChevronDown, IconChevronRight, IconHome, IconMessages } from '@tabler/icons-react';
import { PageType } from '../App';
interface FamilyGroup {
  id: string;
  name: string;
  membersCount: number;
  avatar?: string;
}
interface SideMenuProps {
  isOpen: boolean;
  onClose: () => void;
  currentPage: PageType;
  onNavigate: (page: PageType) => void;
  onNewConversation: () => void;
  onLogout: () => void;
}
// Nuclei familiari di esempio
const familyGroups: FamilyGroup[] = [{
  id: 'family-1',
  name: 'Famiglia Rossi',
  membersCount: 4
}, {
  id: 'family-2',
  name: 'Casa Nonni',
  membersCount: 3
}];
export function SideMenu({
  isOpen,
  onClose,
  currentPage,
  onNavigate,
  onNewConversation,
  onLogout
}: SideMenuProps) {
  const [selectedFamily, setSelectedFamily] = useState<FamilyGroup>(familyGroups[0]);
  const [isFamilyDropdownOpen, setIsFamilyDropdownOpen] = useState(false);
  // Menu items
  const menuItems = [{
    icon: IconHome,
    label: 'Home',
    sublabel: null,
    badge: null,
    action: () => {
      onNavigate('home');
      onClose();
    }
  }, {
    icon: IconPlus,
    label: 'Nuova Conversazione',
    sublabel: null,
    badge: null,
    action: () => {
      onNewConversation();
      onClose();
    }
  }, {
    icon: IconMessages,
    label: 'Le mie conversazioni',
    sublabel: null,
    badge: null,
    action: () => {
      onNavigate('history');
      onClose();
    }
  }, {
    icon: IconSquareCheck,
    label: 'Attività',
    sublabel: null,
    badge: 21,
    action: () => {
      onNavigate('activities');
      onClose();
    }
  }, {
    icon: IconUsersGroup,
    label: 'Nucleo Familiare',
    sublabel: null,
    badge: null,
    action: () => {
      onNavigate('family');
      onClose();
    }
  }, {
    icon: IconSettings,
    label: 'Impostazioni',
    sublabel: null,
    badge: null,
    action: () => {
      onNavigate('settings');
      onClose();
    }
  }];
  const handleLogout = () => {
    onClose();
    onLogout();
  };
  const handleFamilySelect = (family: FamilyGroup) => {
    setSelectedFamily(family);
    setIsFamilyDropdownOpen(false);
  };
  return <>
      {/* Backdrop */}
      <div className={`fixed inset-0 bg-yeppy-text bg-opacity-20 z-40 transition-opacity duration-300 ${isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`} onClick={onClose} aria-hidden="true" data-id="element-286" />

      {/* Drawer */}
      <div className={`fixed top-0 left-0 bottom-0 w-[320px] bg-yeppy-bg z-50 transform transition-transform duration-300 ease-out flex flex-col ${isOpen ? 'translate-x-0' : '-translate-x-full'}`} role="dialog" aria-modal="true" aria-label="Menu di navigazione" data-id="element-287">
        {/* Logo Section */}
        <div className="p-6" data-id="element-288">
          <img src="https://cdn.magicpatterns.com/uploads/bgucnc6iAv4SE4noNyVpoM/Logo_esteso.svg" alt="Yeppy" className="h-6 w-auto" data-id="element-289" />
          <p className="font-poppins text-xs text-yeppy-text/50 mt-3" data-id="element-290">
            Alleggerisci il tuo carico mentale
          </p>
        </div>

        {/* Family Selector */}
        <div className="px-4 py-3 border-b border-yeppy-text border-opacity-10" data-id="element-291">
          <p className="font-poppins text-xs font-medium text-yeppy-text text-opacity-50 mb-2 px-1" data-id="element-292">
            NUCLEO FAMILIARE
          </p>
          <div className="relative" data-id="element-293">
            <button onClick={() => setIsFamilyDropdownOpen(!isFamilyDropdownOpen)} className="w-full flex items-center gap-3 p-3 bg-white border border-yeppy-text border-opacity-10 rounded-2xl transition-colors" data-id="element-294">
              <div className="w-10 h-10 rounded-full bg-yeppy-bg flex items-center justify-center flex-shrink-0" data-id="element-295">
                <IconUsersGroup className="w-5 h-5 text-yeppy-text" stroke={1.5} data-id="element-296" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-297">
                <p className="font-poppins text-sm font-medium text-yeppy-text" data-id="element-298">
                  {selectedFamily.name}
                </p>
                <p className="font-poppins text-xs text-yeppy-text text-opacity-50" data-id="element-299">
                  {selectedFamily.membersCount} membri
                </p>
              </div>
              <IconChevronDown className={`w-5 h-5 text-white text-opacity-60 transition-transform duration-300 ${isFamilyDropdownOpen ? 'rotate-180' : ''}`} stroke={1.5} data-id="element-300" />
            </button>

            {/* Family Dropdown */}
            {isFamilyDropdownOpen && <>
                <div className="fixed inset-0 z-10" onClick={() => setIsFamilyDropdownOpen(false)} data-id="element-301" />
                <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-yeppy-text border-opacity-15 rounded-2xl overflow-hidden z-20 shadow-lg" style={{
              animation: 'dropdownSlideDown 0.2s ease-out'
            }} data-id="element-302">
                  {familyGroups.map((family, index) => <button key={family.id} onClick={() => handleFamilySelect(family)} className={`w-full px-3 py-3 text-left transition-colors ${index !== 0 ? 'border-t border-yeppy-text border-opacity-10' : ''} ${selectedFamily.id === family.id ? 'bg-yeppy-bg' : ''}`} data-id="element-303">
                      <div className="flex items-center gap-3" data-id="element-304">
                        <div className="w-8 h-8 rounded-lg bg-yeppy-green bg-opacity-30 flex items-center justify-center flex-shrink-0" data-id="element-305">
                          <IconHome className="w-4 h-4 text-yeppy-text" stroke={1.5} data-id="element-306" />
                        </div>
                        <div data-id="element-307">
                          <p className="font-poppins text-sm font-medium text-yeppy-text" data-id="element-308">
                            {family.name}
                          </p>
                          <p className="font-poppins text-xs text-yeppy-text text-opacity-50" data-id="element-309">
                            {family.membersCount} membri
                          </p>
                        </div>
                      </div>
                    </button>)}

                  {/* Join/Create Family */}
                  <button onClick={() => {
                setIsFamilyDropdownOpen(false);
                // TODO: Open join/create family modal
              }} className="w-full px-3 py-3 text-left transition-colors border-t border-yeppy-text border-opacity-10" data-id="element-310">
                    <div className="flex items-center gap-3" data-id="element-311">
                      <div className="w-8 h-8 rounded-lg bg-yeppy-bg flex items-center justify-center flex-shrink-0 border border-yeppy-text border-opacity-10" data-id="element-312">
                        <IconPlus className="w-4 h-4 text-yeppy-text" stroke={1.5} data-id="element-313" />
                      </div>
                      <span className="font-poppins text-sm text-yeppy-text" data-id="element-314">
                        Unisciti o crea nucleo
                      </span>
                    </div>
                  </button>
                </div>
              </>}
          </div>
        </div>

        {/* Main Menu - List Layout */}
        <div className="px-4 py-4 flex-1" data-id="element-315">
          <div className="space-y-1" data-id="element-316">
            {menuItems.map(item => <button key={item.label} onClick={item.action} className="w-full flex items-center gap-3 p-3 rounded-xl transition-colors active:bg-white active:bg-opacity-60 hover:bg-white hover:bg-opacity-40" data-id="element-317">
                <div className="w-9 h-9 rounded-xl bg-white bg-opacity-60 flex items-center justify-center flex-shrink-0 border border-yeppy-text border-opacity-5" data-id="element-318">
                  <item.icon className="w-5 h-5 text-yeppy-text" stroke={1.5} data-id="element-319" />
                </div>
                <div className="flex-1 text-left" data-id="element-320">
                  <span className="font-poppins text-sm font-medium text-yeppy-text block" data-id="element-321">
                    {item.label}
                  </span>
                  {item.sublabel && <span className="font-poppins text-xs text-yeppy-text text-opacity-60 block" data-id="element-322">
                      {item.sublabel}
                    </span>}
                </div>
                {item.badge !== null ? <span className="px-2 py-0.5 rounded-full text-xs font-poppins font-semibold bg-yeppy-green bg-opacity-20 text-yeppy-text" data-id="element-323">
                    {item.badge}
                  </span> : <IconChevronRight className="w-4 h-4 text-yeppy-text text-opacity-30" stroke={1.5} data-id="element-324" />}
              </button>)}
          </div>
        </div>

        {/* Bottom Section - Logout Button */}
        <div className="p-4 border-t border-yeppy-text border-opacity-10" data-id="element-325">
          <button onClick={onLogout} className="w-full flex items-center gap-4 px-4 py-3.5 rounded-2xl text-yeppy-text text-opacity-60 hover:bg-yeppy-text hover:bg-opacity-5 transition-all" data-id="element-326">
            <IconLogout className="w-6 h-6" stroke={1.5} data-id="element-327" />
            <span className="font-poppins text-base font-medium" data-id="element-328">Logout</span>
          </button>
        </div>

        <style jsx data-id="element-329">{`
          @keyframes dropdownSlideDown {
            from {
              opacity: 0;
              transform: translateY(-8px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>
      </div>
    </>;
}